import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { SessionStorageKeys } from '../../SessionStorageKeys';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { SessionService } from '../session/session.service';

declare const window: Window &
  typeof globalThis & {
    duid: any;
  };

@Injectable({
  providedIn: 'root',
})
export class DeviceHandlerService {
  private _deviceId: string;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private readonly session: SessionService, private localStorage: LocalStorageService) {}

  public getCurrentDeviceID(): string {
    if (!this.localStorage.isDefined()) {
      if (!this._deviceId) {
        this._deviceId = this.generateDuid();
      }
      return this._deviceId;
    }
    if (this._deviceId) {
      this.localStorage.setItem(LocalStorageKeys.DEVICEREF, this._deviceId);
    }
    let id = this.localStorage.getItem(LocalStorageKeys.DEVICEREF);

    // Avoids creating a new deviceID for existing Session ID
    const sessionNotDefined = this.session.getSessionID() === undefined;

    // If session doesn't exist, can create new device ID
    if (sessionNotDefined) {
      // generate a new DUID if id is null or empty
      while (id === null || (id !== null && id.trim().length === 0)) {
        id = this.generateDuid();
        this.localStorage.setItem(LocalStorageKeys.DEVICEREF, id);
      }
    } else {
      if (
        id === null ||
        (id !== null && id?.trim().length === 0) ||
        id === undefined ||
        id?.trim().toUpperCase() === 'NULL' ||
        id?.trim().toUpperCase() === 'UNDEFINED'
      ) {
        // This case should not happen, as the session is defined, therefore there must be a deviceref already in localStorage
        id = this.generateDuid();
        this.localStorage.setItem(LocalStorageKeys.DEVICEREF, id);
        const newSessionId = this.generateDuid();
        sessionStorage.setItem(SessionStorageKeys.SESSIONID, newSessionId.replace(/-/g, ''));
      }
    }

    return id;
  }

  /**
   * Get the device uid if the device is a tizen device, otherwise generate a uuid
   *
   * @returns device uid
   */
  generateDuid(): string {
    const userAgent = navigator.userAgent.toLowerCase();
    const isSmartTV = userAgent.includes('tizen') || userAgent.includes('web0s') || userAgent.includes('vizio');
    // Validar si el useragent contiene la palabra 'web0s' o 'tizen'
    if (isSmartTV && window.duid) {
      const duid = window.duid;
      return duid;
    }
    return uuid();
  }
}
